import React from "react";
import { Header } from "@/components/header";
import useMonitoredMetersForOrganization from "@/meters/useMonitoredMetersForOrganization";
import MetersTable from "@/meters/MetersTable";
import { Alert } from "@/components/ui/alert";
import { useThaloWeb } from "@/contexts/ThaloWebContext";
import BuildingGraphic from "@/assets/skyline_transparent.png";
import { cn } from "@/lib/utils";

const NoMetersDialog = () => {
  const { selectedOrganization } = useThaloWeb();
  return (
    <Alert
      className="lg:w-3/4 overflow-hidden z-10 absolute top-20">
      <div className="p-8 pb-16">
        <p className="mb-4">
          <b>{selectedOrganization.name}</b> currently has no meters being monitored by Thalo's AI Vision Engine.
        </p>
        <p className="mb-4">
          Organizations that use Thalo's meter monitoring solution have access to 24/7 automatic meter usage data,
          estimated fuel spend, and emissions statistics, without the need for manual meter readings.
        </p>
        <p>
          To set up meter monitoring, please <a className="underline text-thalo-blueLight"
                                                href="mailto:hello@thalolabs.com">contact your account manager</a>.
        </p>
      </div>
      <img
        src={BuildingGraphic}
        alt="Building Graphic"
        className="absolute -translate-y-1/3 translate-x-1/4 right-0 w-2/3 overflow-hidden"
      />
    </Alert>
  );
};

const MetersPage = () => {
  const { meters } = useMonitoredMetersForOrganization();
  const count = meters.data?.data.count;

  return (
    <>
      <Header
        name="Meters"
        showDatePicker={false}
        showChartOptions={false}
        className="font-normal text-4xl"
      />
      <div className="relative flex justify-center items-center">
        <div className={cn("w-full", count === 0 ? "blur-sm select-none pointer-events-none opacity-40" : '')}>
          <p className="mb-4">
            Thalo is currently monitoring <span
            className="text-thalo-blueLight">{count} meter{count !== 1 ? 's' : ''}</span> with Thalo's AI Vision
            Engine,{' '}
            providing you with new data for smarter emissions management.
          </p>
          <div className="overflow-x-scroll">
            <MetersTable/>
          </div>
        </div>
        {
          count === 0 && (
            <NoMetersDialog />
          )
        }
      </div>
    </>
  )
}

export default MetersPage;
